import { render, staticRenderFns } from "./PubchemRecordsSection.vue?vue&type=template&id=4c2fb960"
import script from "./PubchemRecordsSection.vue?vue&type=script&lang=js"
export * from "./PubchemRecordsSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports